import { SessionState } from "./sip.js/index.js"
import * as externalTranscriber from "./externalTranscribers/index.js"
import { transcriptUpload } from "../actions/calls.js"

export const SetCallID = id => externalTranscriber.SetCallID(id)

export const startCallTranscription = session => {
    externalTranscriber.Permitted(true)
    session.stateChange.addListener(state => {
        console.log("Call state changed to:", state)

        switch (state) {
            case SessionState.Established:
                externalTranscriber.Init()
                const { peerConnection } = session.sessionDescriptionHandler
                peerConnection.getReceivers().forEach(({ track }) => {
                    externalTranscriber.ProcessAudioTrack("customer", track)
                })

                peerConnection.getSenders().forEach(({ track }) => {
                    externalTranscriber.ProcessAudioTrack("agent", track)
                })

                break
            case SessionState.Terminated:
                externalTranscriber.Finish(transcriptUpload)

                console.log("+++ Call terminated")
                break
            default:
        }
    })
}
